module.exports = __webpack_public_path__ + "img/used_help.be37d4fc.svg";